import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import { formatForLabel } from 'bundles/apex/deals/show/listing/helpers';

export function ListingValue({ isParentDeal, label, listing, name, project, value }) {
  const source = isParentDeal ? project : listing;
  value = value == null ? source[name] : value;
  label = label == null ? formatForLabel(name) : label;

  if (!value) return null;

  return (
    <tr>
      <th className="bg-transparent text-nowrap px-0 py-1">{label}</th>
      <td className="bg-transparent pe-0 ps-4 py-1">{value}</td>
    </tr>
  );
}

ListingValue.propTypes = {
  isParentDeal: PropTypes.bool,
  label: PropTypes.string,
  listing: PropTypes.object,
  name: PropTypes.string.isRequired,
  project: PropTypes.object,
  value: PropTypes.any,
};

const mapStateToProps = ({ deal }) => ({
  isParentDeal: deal.parent,
  listing: deal.listing,
  project: deal.project,
});

export default connect(mapStateToProps)(ListingValue);
